export default __webpack_public_path__ + "static/footer_bg-608de8add088f8de137b52d2205420b5.jpg";